import { createContext, useContext, useEffect, useState } from "react";
import { api, getStoredUser, setStoredUser, setToken, clearToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(!!getToken() && !getStoredUser());

  useEffect(() => {
    let mounted = true;
    const t = getToken();
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { if (mounted) { setUser(r.data); setStoredUser(r.data); } })
      .catch(() => { clearToken(); if (mounted) setUser(null); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.data.token);
    setStoredUser(r.data.user);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (name, email, password) => {
    const r = await api.post("/auth/register", { name, email, password });
    setToken(r.data.token);
    setStoredUser(r.data.user);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    clearToken();
    setUser(null);
    window.location.href = "/login";
  };

  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    setStoredUser(r.data);
    return r.data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
